export const NFT_LISTED = "nft-listed/";
export const SOLSEA_MAINNET_URL = "https://api.all.art/";
export const SOLSEA_REFRESH_URI = "https://test-api.solsea.io/v1/wallet/";
export const RELOAD = "?reload=true";
export const SOLSEA_DEVNET_WEBSITE = "https://solsea-test.ha.rs/";
